import {
  Component,
  ContentChild,
  Input,
  TemplateRef,
  inject,
} from '@angular/core';
import {
  FormBuilder,
  FormGroup,
  FormsModule,
  ReactiveFormsModule,
} from '@angular/forms';
import { NgTemplateOutlet } from '@angular/common';

@Component({
  selector: 'app-form-template',
  templateUrl: './form-template.component.html',
  styleUrls: ['./form-template.component.scss'],
  imports: [FormsModule, ReactiveFormsModule, NgTemplateOutlet],
})
export class FormTemplateComponent {
  private fb = inject(FormBuilder);

  @Input() formGroup: FormGroup = this.fb.record({});

  @ContentChild('titleTemplate', { static: false })
  titleTemplateRef?: TemplateRef<any>;
  @Input() title?: string;

  @Input() submit: () => void | Promise<void> = () => {};

  onSubmit() {
    if (this.submit) {
      this.submit();
    }
  }
}
